import React from "react";
import { useTranslation } from "react-i18next";

import { useDeleteTariff } from "~/entity/Ivideon/hooks/useDeleteTariff";
import {
  useURLParamsGetter,
  useURLParamsSetter,
} from "~/hooks/useURLParamsSetter";
import { useNotify } from "~/shared/hooks/useNotify";
import { ConfirmModal } from "~/shared/ui/ConfirmModal";

const IvideonDeleteModal = ({ reFetch }: { reFetch: () => void }) => {
  const { t } = useTranslation();
  const { remove } = useDeleteTariff();
  const { openModal, currentId } = useURLParamsGetter<{
    openModal: string;
    currentId: string;
  }>();
  const setParams = useURLParamsSetter();

  const isOpen = ["Sure"].includes(openModal);
  const { notifySuccess, notifyError } = useNotify();

  const closeModal = () => setParams({ openModal: "", currentId: "" });

  const removeHandle = () => {
    const data = { id: Number(currentId) };
    remove(data, {
      onSuccess: () => {
        notifySuccess(t("ivideonPlans.deletePlan"));
        reFetch();
        closeModal();
      },
      onError: (error) => {
        notifyError(error.message);
        closeModal();
      },
    });
  };

  return (
    <ConfirmModal
      open={isOpen && openModal !== "ViewIdentifiers"}
      title={t("ivideonPlans.deleteModalTitle")}
      onConfirm={removeHandle}
      onCancel={closeModal}
      closable
      centered
      destroyOnHidden
    />
  );
};

export default IvideonDeleteModal;
